import { defineStore } from "pinia";
import { ref } from "vue";
import type { MenuModel } from "../types/shopify";
import { useMenu } from "../composables/shopify";



export const useMenuStore = defineStore("menu", () => {
  // State: lagrar menyer med handle som nyckel
  
  
  const menusByHandle = ref<Record<string, MenuModel>>({});
  

  // Setter
  function setMenuByHandle(handle: string, menu: MenuModel) {
    menusByHandle.value[handle] = menu;
  }

  // Getters
  function getMenuByHandle(handle: string): MenuModel | undefined {
    return menusByHandle.value[handle];
  }

   // Hämtar meny via composable-funktionen om den inte redan finns i storen
   async function fetchMenuByHandle(handle: string): Promise<MenuModel | null> {
    if (menusByHandle.value[handle]) {
      return menusByHandle.value[handle];
    }
    try {
      const { data } = await useMenu(handle);
      if (data && data.value && data.value.menu) {
        setMenuByHandle(handle, data.value.menu);
        return data.value.menu;
      } else {
        console.warn(`No menu data found for handle: ${handle}, data:`, data);
        return null;
      }
    } catch (error) {
      console.error(`Error fetching menu for handle ${handle}:`, error);
      return null;
    }
  }
  

  // Hjälpfunktioner
  function stripDomain(url?: string) {
    if (!url) return "";
    return url.replace(/^https?:\/\/[^/]+/, "").replace(/^\/pages/, "");
  }
  function getSlug(url?: string) {
    if (!url) return "";
    const parts = url.split("/");
    return parts[parts.length - 1] || "";
  }
  function fetchMenus(name?: string) {
    return "";
  }

  return {
    menusByHandle,
    fetchMenus,
    fetchMenuByHandle,
    setMenuByHandle,    
    getMenuByHandle,
    stripDomain,
    getSlug
  };
});
